import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MetricStat = ({
  icon,
  iconSrc,
  label,
  value,
  color = "#2563eb",
  subValue,
  subValueColor,
  boxed = false,
  horizontal = false,
  highlighted = false,
}) => {
  if (horizontal) {
    return (
      <div className="pd-stat pd-stat-horizontal">
        <div className="pd-stat-head">
          {iconSrc ? (
            <img src={iconSrc} alt={label} className="pd-stat-icon-img" />
          ) : (
            <span className="pd-stat-icon" style={{ background: color }}>
              <FontAwesomeIcon icon={icon} />
            </span>
          )}
          <span className="pd-stat-label">{label}</span>
        </div>
        <span className="pd-stat-value" style={{ color }}>
          {value}
        </span>
        {subValue ? (
          <span
            className="pd-stat-sub"
            style={{ color: subValueColor || color }}
          >
            {subValue}
          </span>
        ) : null}
      </div>
    );
  }

  return (
    <div
      className={`pd-stat${boxed ? " pd-stat-boxed" : ""}${
        highlighted ? " pd-stat-highlighted" : ""
      }`}
    >
      {iconSrc ? (
        <img src={iconSrc} alt={label} className="pd-stat-icon-img pd-stat-icon-img-vertical" />
      ) : (
        <span className="pd-stat-icon" style={{ background: color }}>
          <FontAwesomeIcon icon={icon} />
        </span>
      )}
      <span className="pd-stat-label">{label}</span>
      <span className="pd-stat-value" style={{ color }}>
        {value}
      </span>
      {subValue ? (
        <span
          className="pd-stat-sub"
          style={{ color: subValueColor || color }}
        >
          {subValue}
        </span>
      ) : null}
    </div>
  );
};

export default MetricStat;
